import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: AdviceState = {
    all: [],
};

const rootState: AdviceState = initialState;

const getters: GetterTree<AdviceState, RootState> = {
    all(state: AdviceState): Advice[] | undefined {
        return state.all;
    },
};

const mutations: MutationTree<AdviceState> = {
    RESET(state: AdviceState) {
        state.all = [];
    },
    SET_ADVICE(state: AdviceState, payload: Advice[]) {
        state.all = payload;
    },
    ADD_ADVICE(state: AdviceState, payload: Advice) {
        if (state.all) {
            state.all.push(payload);
        }
    },
    UPDATE_ADVICE(state: AdviceState, payload: Advice) {
        // TODO ADvice
    },
    DELETE_ADVICE(state: AdviceState, payload: Advice) {
        if (state.all) {
            state.all = state.all.filter((advice: Advice) => advice.id !== payload.id);
        }
    },
};

const actions: ActionTree<TimelineState, RootState> = {
    create({ commit }, payload: AdvicePayload): any {
        // @ts-ignore
        return this._vm.$api.post(`users/${payload.user_id}/advice`, payload, { withCredentials: true })
            .then((response: { data: Advice }) => {
                commit('ADD_ADVICE', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    read({ commit }, payload: { user_id: number, afvice_id: number }): any {
        // @ts-ignore
        return this._vm.$api.get(`users/${payload.user_id}/advice/${payload.advice_id}`, { withCredentials: true })
            .then((response: { data: Advice }) => {
                commit('SET_ADVICE', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    update({ commit }, payload: AdvicePayload): any {
        // @ts-ignore
        return this._vm.$api.put(`users/${payload.user_id}/advice/${payload.advice_id}`, { withCredentials: true })
            .then((response: { data: Advice }) => {
                commit('UPDATE_ADVICE', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    delete({ commit }, payload: { user_id: number, resource_id: number }): any {
        // @ts-ignore
        return this._vm.$api.delete(`users/${payload.user_id}/advice/${payload.resource_id}`, { withCredentials: true })
            .then((response: { data: Advice }) => {
                commit('DELETE_ADVICE', { id: payload.resource_id });
                commit('timeline/DELETE_ENTRY', { id: `advice:${payload.resource_id}` }, { root: true });

                return Promise.resolve({ id: payload.resource_id });
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
